import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducers from '../reducers';

// setup redux devtools chrome extension connection
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd/related
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const store = createStore(
	reducers,
	composeEnhancers(applyMiddleware(thunk)),
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store/store.js